module.exports = {
  cmpLandingPage: {
    announcement: {
      title: '新型コロナウイルスによるお客様へのお願い',
      text: {
        '1':
          'ご参加いただくお客様におかれましては、以下の新型コロナウィルス感染予防対策へのご協力をお願い申し上げます。',
        '2': '<b>運営方針及びお客様へのお願い</b>',
        '3': `
           ・「密閉」「密集」「密接」の3密を避けるため、お客様には予約日時にスタート地点現地へお越しいただき、ご自身で遠隔スタートしていただきます。具体的なスタート方法につきましては、ご予約後にご案内させていただきます。<BR>
           ・マスクは必ず着用のうえ、ご参加ください。<BR>
           ・ご予約は3名様まで可能です。4名様以上でのご参加は承っておりません。<BR>
           ・同一スロットに他のお客様がいらっしゃった場合、2m以上の距離を空けてご体験ください。<BR>
           ・電車等をご利用のうえでのご参加は極力ご遠慮ください。<BR>
           ・ご体調の悪い方はご参加をご遠慮ください。体験中に何かトラブル等がございましたら、LINE公式アカウント（<a target="_blank" rel="noopener" href="https://pretiaar.com/contact/">https://pretiaar.com/contact/</a>）までご連絡ください。<BR>
         `
      },
      link: {
        orders: '予約変更',
        contact: 'お問い合わせ'
      }
    },
    keyVisual: {
      info: {
        '1': 'ようこそ',
        '2': '君がここに来ることは分かっていたよ',
        '3': 'さあ、【我々】と一緒に謎を解き明かしに行こう'
      },
      story: {
        '1': '突如【この街】が何者かに奪われてしまった…',
        '2':
          '「零夜」と協力して現実世界のポータルキーを集めてこの街を取り戻そう。',
        '3': 'ポータル制圧にはいくつもの謎に挑むことになる。',
        '4': 'ヒーローたちと協力してすべての謎を解き明かせ！'
      }
    },
    hotToPlay: {
      intro: {
        '1': '街を歩き回り、怪しいものを見つけよう！',
        '2': '',
        '3': '謎をすべて解いて、事件を解決しよう！'
      }
    },
    characters: {
      bottommsg: '登場する他のヒーローにも会いに行こう！',
      reiya: {
        name: '零夜',
        furigana: '(れいや)',
        bio: {
          '1': '怪しい秘密結社”MMM”の首脳',
          '2': 'とある事件を起こし 公安から逃走中'
        },
        cv: '斉藤 壮馬',
        painter: 'ちゃもーい'
      },
      ouka: {
        name: '桜華　忠臣',
        furigana: '(おうか ただおみ)',
        bio: {
          '1': '総帥と呼ばれるこの男の素性は',
          '2': '決して口にしてはいけない'
        },
        cv: '柿原　徹也',
        painter: 'りゅうせー'
      },
      gustav: {
        name: 'グスタフ ハイドリヒ',
        furigana: '',
        bio: {
          '1': '毒兵器をまとう残虐な軍団指揮官',
          '2': '「桜華忠臣」の同盟国で世界一統を企てる'
        },
        cv: '山路　和弘',
        painter: 'りゅうせー'
      },
      kirara: {
        name: '輝龍院 きらら',
        furigana: '(きりゅういん きらら)',
        bio: {
          '1': '世界を裏で支配する忍者集団の若き頭領',
          '2': '生放送したりファンクラブがあったりでまったく忍んでない'
        },
        cv: '喜多村　英梨',
        painter: 'apapico'
      },
      megumegu: {
        name: 'メグメグ',
        furigana: '',
        bio: {
          '1': 'おませで危険な兵器マニアの少女',
          '2': '愛用の「ガトりん」で嗜虐の限りを尽くす'
        },
        cv: '佐倉　綾音',
        painter: 'ぽあろ'
      },
      thirteen: {
        name: '１３♰サーティーン♰',
        furigana: '',
        bio: {
          '1': '"元"天使、今はワケあって死神',
          '2': '「＃コンパス」の世界に潜り込む'
        },
        cv: '小野　大輔',
        painter: '緋紅&NHN PlayArt'
      }
    },
    participate: {
      subtitle: '参加方法',
      no1: {
        no: '１',
        label: '場所・日時を選ぶ',
        explanation: '遊びたい日時を決め、WEBから予約'
      },
      no2: {
        no: '２',
        label: '予約メールを確認',
        explanation: '当日の持ち物や注意事項が記載されています'
      },
      no3: {
        no: '３',
        label: 'ゲーム開始',
        explanation: '出発準備をしゲーム開始'
      }
    },
    about: {
      subtitle: '『PSYCHO-PASS サイコパス』とは',
      main: {
        '1':
          '魂を数値化する巨大監視ネットワーク・シビュラシステムが人々の治安を維持している近未来。',
        '2':
          '変わりゆく世界で、犯罪に関する数値〈犯罪係数〉を測定する銃〈ドミネーター〉を持つ刑事たちは、犯罪を犯す前の〈潜在犯〉を追う。'
      },
      link: 'アニメ公式サイトへ'
    },
    information: {
      subtitle: '詳細情報',
      timeLimit: '制限時間',
      minute: '分',
      playTime: '体験時間',
      notice: '（ゲーム準備を含む。所要時間は個人差があります。）',
      variableTimeWarning: '※所要時間は個人差があります',
      limitedTimeWarning: '※制限時間あり',
      playerCapacity: 'プレイ人数',
      price: '料金',
      location: {
        label: '開始地点',
        warning: '東京会場：開催終了',
        warning2: '大阪会場：道頓堀橋周辺',
        warning3: '名古屋会場：テレビトーヒロバ周辺'
      },
      weekday: '',
      holiday: '',
      noPlayerLimit: '1人〜3人',
      continue: '(コンティニュー課金あり)',
      belongings: {
        label: '持ち物',
        value: '当アプリに対応したスマートフォン'
      }
    },
    goods: {
      subtitle: '謎解きイベントオフィシャルグッズ'
    },
    footer: {
      terms: '利用規約',
      policy: 'プライバシーポリシー',
      salesNotice: '特定商取引法に基づく表記',
      contact: 'お問い合わせ',
      disclaimer: '免責事項',
      copyright: {
        nhn: '©NHN PlayArt Corp.',
        nico: '©DWANGO Co., Ltd.',
        pretia: '©Pretia Technologies. Inc.'
      }
    }
  },
  landingPage: {
    information: {
      playTime: 'プレイ時間',
      variableTimeWarning: '※所要時間は個人差があります',
      limitedTimeWarning: '※制限時間あり',
      playerCapacity: 'プレイ人数',
      price: '料金',
      location: {
        label: '開始地点',
        warning: '※具体的な行き先はゲーム開始後に指示がございます'
      },
      weekday: '平日',
      holiday: '休日',
      noPlayerLimit: '1人〜3人',
      belongings: {
        label: '持ち物',
        value: '1当アプリに対応したスマートフォン'
      }
    },
    devices: {
      subtitle: '対応スマートフォン',
      rental: {
        title: 'スマホレンタルにつきまして',
        text: {
          '1':
            '店舗閉鎖に伴い、誠に勝手ながら、スマホレンタルのご案内も廃止とさせていただきます。',
          '2':
            'つきましては、原則としまして、対応端末をお持ちの方のみのご案内となりますこと、予めご了承くださいませ。',
          '3':
            '対応端末をお持ちでないお客様におかれましては、お連れ様との端末シェアにご同意いただける場合に限り、ご予約を承ることが可能です。<br/>このような場合でも、参加料につきましては、人数分をお支払い頂きますようお願いいたします。'
        }
      }
    },
    news: {
      subtitle: 'ニュース'
    },
    faq: {
      subtitle: 'よくある質問',
      allButton: '全てのFAQはこちら'
    },
    warning: {
      subtitle: '注意事項',
      '1': 'アプリの通知と位置情報は許可してください',
      '2': '遊ぶ前は十分スマホを充電してきてください',
      '3': 'ゲーム中のアプリ切替え・画面オフはできません',
      '4': '遊んだ後はネタバレはご遠慮下さい',
      '5': '街の人にゲームのことを聞かないでください',
      '6': '人にぶつかると危ないので、走らないでください',
      '7': '歩きスマホはご遠慮下さい',
      '8': '集団で道路にたまったりしないでください',
      '9': 'キャッチについていかないでください',
      '10': '地図にない建物はゲームをプレイする上で考慮する必要はありません',
      '11': '写真撮影は人が映りこまないようにお願いします',
      '12': '歩きやすい靴でお越しください'
    },
    footer: {
      terms: '利用規約',
      policy: 'プライバシーポリシー',
      salesNotice: '特定商取引法に基づく表記',
      contact: 'お問い合わせ',
      disclaimer: '免責事項'
    },
    book: {
      nextStepShort: '予約'
    }
  }
};
